import { useAuth } from '../lib/auth/hooks/useAuth'
import { userClaimIds } from '../utils/userClaims'

export function useCustomerId(): string | undefined {
  const { user } = useAuth()
  return user ? user[userClaimIds.netSuiteId] : undefined
}
